import React, { useRef, useEffect, useState } from 'react';
import format from 'date-fns/format';
import { useNavigate, useLocation } from '@reach/router';
import { Button, Typography, Grid } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { Slices, Redux } from 'spwa-ui-library';
import { orderStatusHelper, decimalChecker } from 'spwa-ui-library/esm/utils/helper';
import { BsArrowClockwise } from '@react-icons/all-files/bs/BsArrowClockwise';
// import noImg from '../../assets/no-itm.png';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
import { AiOutlineArrowUp } from '@react-icons/all-files/ai/AiOutlineArrowUp';
import ReOrder from '../ReOrder';
// import cart from './images/cart.svg';
const { useSelector } = Redux;
const { orderStatusConstants, selectCountryValidations } = Slices.configSlice;
// const { selectFirstMenu } = Slices.menuSlice;
const { selectPreviousOrders, selectCurrentOrders } = Slices.orderSlice;

// useSelector fetch orders

function EasyOrderDesktop({ widgetData }) {
  const intl = useIntl();
  const location = useLocation();
  const navigate = useNavigate();
  const page = 'orders';
  // const imgBaseUrl = useSelector(selectBaseURL);
  const orderStatusArray = useSelector(orderStatusConstants);
  const orders = useSelector(selectPreviousOrders);
  const currentOrders = useSelector(selectCurrentOrders);
  const auth = useSelector((state) => state.auth);
  const profile = useSelector((state) => state.profile);
  const [open, setOpen] = useState(null);
  const [isReorderEnabled, setEnableReOrder] = useState(false);
  const [selectedOrders] = useState(3);
  const ref = useRef(null);
  const childComponentRef = useRef();

  const orderState = useSelector((state) => state.order);
  const nextPage = orderState?.previousOrders?.info?.data?.nextPage;

  const countryValidations = useSelector((state) =>
    selectCountryValidations(state, profile.country)
  );
  const currency = countryValidations && countryValidations.currency;

  const handleOpen = (e) => {
    setOpen(!open);
  };
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);

  useEffect(() => {
    if (childComponentRef && childComponentRef.current && isReorderEnabled) {
      childComponentRef.current.addCart();
    }
  }, [childComponentRef, isReorderEnabled]);

  const handleReorder = () => {
    if (countryValidations?.enableReorder) {
      setEnableReOrder((pre) => !pre);
      return;
    }
  };

  if (!countryValidations?.enableReorder) {
    return '';
  }

  const handleNavigation = (id, status) => () => {
    if (status === 'PENDING') {
      navigate(`/${intl.locale}/thank-you/` + id);
    } else {
      navigate(`/${intl.locale}/order-detail/` + id, {
        state: {
          oldLocation: JSON.parse(JSON.stringify(location)),
        },
      });
    }
  };
  const openOrderHistory = () => {
    navigate(`/${intl.locale}/order-history`, {
      state: {
        oldLocation: JSON.parse(JSON.stringify(location)),
      },
    });
  };

  if (Array.isArray(currentOrders) && currentOrders.length > 0) {
    return null;
  }

  if (!auth.isLoggedIn) {
    return null;
  }
  if (orders.length === 0) return null;

  return (
    <section className={css.root}>
      <Box ref={ref} className={open ? css.openContainer : css.container}>
        <Box className={css.btnContainer} onClick={handleOpen}>
          <Typography id="previouslyOrdered" className={css.previousItem}>
            <FormattedMessage id={'previousOrdered'} defaultMessage={`Previous Orders`} />
          </Typography>
          <AiOutlineArrowUp className={open ? css.arrowdownicon : css.arrowupicon} />
        </Box>
        <Box style={{ overflowY: orders.length >= 3 ? 'scroll' : 'none' }}>
          {orders.slice(0, 3).map((item, i) => {
            const imgSrc = item?.assets[0]?.src;
            const itemDetail = item?.name;
            let orderQty = item?.itemIds.length || item?.itemIdAndTypeIds?.length || item?.qty;

            let d =
              item?.advanceTime === 0
                ? new Date(item?.createdAt)
                : new Date(item?.advanceTime); /* midnight in China on April 13th */
            const abs = d
              .toLocaleString('en-US', { timeZone: countryValidations?.timezone, hour12: true })
              .split(',');

            const formDate = `${d.getDate()} ${d.toLocaleDateString('en-US', {
              month: 'long',
            })}, ${d.getFullYear()} | ${abs[1]}`;
            return (
              <div className={`${css.main} ${open ? '' : css.hidden}`} key={i}>
                <div className={css.order}>
                  <div className={css.orderMain} onClick={handleNavigation(item._id, item.status)}>
                    <Grid className={css.textBackground}>
                      {item?.status !== 'PENDING' ||
                      (item?.status === 'PENDING' && item.advanceTime !== 0) ? (
                        <>
                          {item?.orderDisplayNumber ? (
                            <h5 className={css.orbNumber}>
                              <FormattedMessage
                                id={'orderdetails_orderno'}
                                defaultMessage="Order No"
                              />{' '}
                              <span className={css.redText}>{item?.orderDisplayNumber}</span>
                            </h5>
                          ) : null}
                        </>
                      ) : (
                        <strong>
                          <FormattedMessage
                            id="pendingConfirmation"
                            defaultMessage="Pending Confirmation"
                          />
                        </strong>
                      )}
                    </Grid>
                  </div>
                  <Grid>
                    <Grid className={css.itemWrapper}>
                      {page === 'feedback' ? (
                        <>
                          <div className={css.itmImg}>
                            <img src={imgSrc} alt="" />
                          </div>
                          <div className={css.feedbackItems}>
                            <Grid className={css.orderCount}>
                              {orderQty}
                              &nbsp;
                              {orderQty > 1 ? (
                                <FormattedMessage id="checkout_items" defaultMessage="Items" />
                              ) : (
                                <FormattedMessage id="checkout_item" defaultMessage="Item" />
                              )}
                            </Grid>
                            <Grid className={css.itemDescription}>{itemDetail}</Grid>
                          </div>
                        </>
                      ) : (
                        <Grid className={css.orderCount}>
                          {orderQty}
                          &nbsp;
                          {orderQty > 1 ? (
                            <FormattedMessage id="checkout_items" defaultMessage="Items" />
                          ) : (
                            <FormattedMessage id="checkout_item" defaultMessage="Item" />
                          )}
                        </Grid>
                      )}

                      {page !== 'feedback' && item.advanceTime !== 0 ? (
                        <>
                          |
                          <Grid className={css.advance}>
                            {`${
                              item?.address?.addressSubType === 'STORE' &&
                              item?.address?.addressType === 'PICKUP'
                                ? item?.address?.addressType?.toUpperCase()
                                : item?.address?.addressSubType?.toUpperCase() || 'Delivery'
                            } ${intl.formatMessage({
                              id: 'scheduled_for',
                            })} `}{' '}
                            {formDate}
                          </Grid>
                        </>
                      ) : (
                        page !== 'feedback' && (
                          <>
                            |
                            <span
                              className={
                                item?.status === 'PENDING' ? css.warningColor : css.orderStatus
                              }
                            >
                              {(item?.address?.addressSubType === 'PICKUP' ||
                                item?.address?.addressSubType === 'DINEIN' ||
                                item?.address?.addressSubType === 'STORE') &&
                              item?.status === 'ON_THE_WAY'
                                ? 'READY FOR PICKUP'
                                : orderStatusArray.length > 0 &&
                                  orderStatusHelper(item?.status, orderStatusArray).toUpperCase()}
                            </span>
                          </>
                        )
                      )}
                    </Grid>
                  </Grid>
                  <p className={css.itemDescription}>{itemDetail}</p>
                  <ReOrder orderId={item?._id} ref={childComponentRef} />
                  <div className={css.bottomSec}>
                    <div className={css.amount}>
                      {decimalChecker(item.payment.amount)} {countryValidations?.currency}
                    </div>

                    <div className={css.button}>
                      <Button color="primary" variant="outlined" onClick={handleReorder}>
                        <BsArrowClockwise className={css.styleClockIcon} />
                        <FormattedMessage
                          id="navigation_historyReOrder"
                          defaultMessage="Re Order"
                        />
                      </Button>
                    </div>
                  </div>
                  <h5 className={css.orderIdInfo}>
                    <span>
                      <FormattedMessage id={'trackorder_orderno'} defaultMessage="Order Id" />.
                      <span className={css.bold}>
                        {' '}
                        {item.country} - {item.uOrderRef}
                      </span>{' '}
                    </span>
                    <span>{` | `}</span>
                    <span>{format(new Date(item.createdAt), 'dd MMM, yyyy')}</span>
                  </h5>
                </div>
              </div>
            );
          })}
          {nextPage && nextPage != -1 && (
            <Box className={css.buttonWrapper}>
              <Button
                variant="outlined"
                color="secondary"
                className={css.desktopButton}
                onClick={openOrderHistory}
              >
                <FormattedMessage id={'view_more'} defaultMessage="View More" />
              </Button>
            </Box>
          )}
        </Box>
      </Box>
    </section>
  );
}
export default EasyOrderDesktop;
